import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserAuth } from '../../context/UserAuthContext';
import { FaTimes } from 'react-icons/fa';
import ProfileCompletionGuide from './ProfileCompletionGuide';

const ResetProfileGuide = () => {
    const { t } = useTranslation();
    const { user } = useUserAuth();
    const [showProfileGuide, setShowProfileGuide] = useState(false);
    const [showResetButton, setShowResetButton] = useState(true);

    const handleResetProfileGuide = () => {
        // Clear the session storage to reset profile guide
        if (user) {
            const sessionKey = `session_${user.uid}`;
            sessionStorage.removeItem(sessionKey);
        }
        // Clear the welcome guide session storage for all visitors
        sessionStorage.removeItem('welcomeGuideShown');
        setShowProfileGuide(true);
    };

    const handleCloseProfileGuide = () => {
        setShowProfileGuide(false);
    };

    const handleCloseResetButton = () => {
        setShowResetButton(false);
    };

    // Expose global function for development/testing
    useEffect(() => {
        window.showProfileGuide = () => {
            handleResetProfileGuide();
        };
        
        return () => {
            delete window.showProfileGuide;
        };
    }, [handleResetProfileGuide]);

    // Only show if reset button is not manually closed
    if (!showResetButton) {
        return null;
    }

    return (
        <>
            {/* Fixed-position Reset Profile Guide Button */}
            <div style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#f8f9fa',
                border: '1px solid #dee2e6',
                borderRadius: '4px',
                padding: '0',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                fontSize: '14px',
                fontFamily: 'system-ui, -apple-system, sans-serif'
            }}>
                <button
                    onClick={handleResetProfileGuide}
                    style={{
                        background: 'none',
                        border: 'none',
                        padding: '8px 12px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        color: '#495057',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#e9ecef';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                    }}
                >
                    🔄 {t('resetProfileGuide.resetButton')}
                </button>
                <button
                    onClick={handleCloseResetButton}
                    style={{
                        background: 'none',
                        border: 'none',
                        borderLeft: '1px solid #dee2e6',
                        padding: '8px 10px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        color: '#6c757d',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#e9ecef';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                    }}
                    title={t('resetProfileGuide.closeButton')}
                >
                    <FaTimes size={12} />
                </button>
            </div>

            {/* Profile Completion Guide Modal */}
            <ProfileCompletionGuide 
                show={showProfileGuide} 
                onHide={handleCloseProfileGuide}
            />
        </>
    );
};

export default ResetProfileGuide;